module.exports = __webpack_public_path__ + "img/SDG-02-EN.9b2bd0a9.png";